import { createFileRoute } from '@tanstack/react-router';

import { ClassChargeHistory } from '~pages/payments/class-charge-history/index';

export const Route = createFileRoute(
  '/_auth/_layout/payment/class-charge-history',
)({
  component: ClassChargeHistory,
});
